import { createTheme } from "@mui/material";

const theme = createTheme({
    palette: {
        primary: {
            light: "#99c7f7",
            main: "#197ce6",
            dark: "#0053b3"
        },
        success: {
            main: "#4caf50", // verde
            light: "#aff0c1"
        },
        error: {
            main: "#d32f2f", // rosso
            light: "#ffadad"
        },
        warning: {
            main: "#ed6c02", // arancione
            light: "#ffbf00"
        },
        background: {
            default: "grey.100", // colore di sfondo globale
            paper: "#ffffff" // sfondo di card, modal, ecc.
        },
        text: {
            primary: "#2c3e50", //3f51b5
            secondary: "#555555" //7986cb
        }
    },
    typography: {
        fontFamily: "Roboto, Arial, sans-serif",
        fontSize: 14
    },
    spacing: 8,
    components: {
        MuiCard: {
            styleOverrides: {
                root: {
                    borderRadius: 12,
                    boxShadow: "0 4px 12px rgba(0,0,0,0.08)"
                }
            }
        },
        MuiSlider: {
            styleOverrides: {
                root: {
                    height: 9
                },
                markLabel: {
                    fontSize: "0.7rem",
                    fontWeight: 500,
                    transform: "translateY(10px)",
                    color: "#5f6368",
                    whiteSpace: "nowrap"
                },
                mark: {
                    backgroundColor: "#bdbdbd",
                    height: 8,
                    width: 1,
                    marginTop: -2
                },
                valueLabel: {
                    background: "rgba(63, 81, 181, 0.9)"
                }
            }
        }
    }
});

export default theme;
